export default function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
    n100 = t0 && s[0].slice(-2);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n == 1 && v0) ? 'one'
    : (!v0 || n == 0
      || n != 1 && (n100 >= 1 && n100 <= 19)) ? 'few'
      : 'other';
}
